import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Inicio from "./Inicio";
import NotFoundRoute from './NotFoundRoute';

class Routes extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 

         }
    }

    render() { 
        return ( 
            <Switch>
                <Route exact path="/" component={Inicio}/>
                <Route exact path="*" component={NotFoundRoute}/>
            </Switch>
         );
    }
}
 
export default Routes;